import { GenericTableTranslations } from './generic-table-translations.interface';

/**
 * German translations for the Generic Table component
 * Complete translation set for German language
 */
export const GERMAN_GENERIC_TABLE_TRANSLATIONS: GenericTableTranslations = {
  loading: 'Laden...',
  noDataAvailable: 'Keine Daten verfügbar',

  pagination: {
    entries: 'Einträge',
    show: 'Anzeigen',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    summaryTemplate: '{from} - {to} von {total} Einträgen',
    noEntriesTemplate: 'Keine Einträge gefunden'
  },

  columnSettings: {
    title: 'Spalteneinstellungen',
    close: 'Menü schließen',
    hintBoth: 'Verwenden Sie die Kontrollkästchen, um Spalten ein- oder auszublenden. Verwenden Sie die Pfeilschaltflächen, um die Reihenfolge der Spalten zu ändern.',
    hintVisibility: 'Verwenden Sie die Kontrollkästchen, um Spalten in der Tabelle ein- oder auszublenden.',
    hintReorder: 'Verwenden Sie die Pfeilschaltflächen, um die Reihenfolge der Spalten in der Tabelle zu ändern.',
  },

  sorting: {
    sortAscending: 'Aufsteigend sortieren',
    sortDescending: 'Absteigend sortieren',
    clearSort: 'Sortierung aufheben',
    clearAllSorts: 'Alle Sortierungen aufheben',
    sort: 'Sortieren',
    ascending: 'aufsteigend',
    descending: 'absteigend',
    sortedBy: 'Sortiert {direction}',
    sortedByWithPrecedence: 'Sortiert {direction} (Priorität: {precedence})'
  },

  filtering: {
    filter: 'Filter',
    clearFilter: 'Filter löschen',
    searchPlaceholder: "Suche in '{column}'...",
    filteredPrefix: 'Gefiltert: ',
    selectedItems: '{count} ausgewählt'
  },

  quickfilters: {
    label: 'Schnellfilter:',
    applyFilter: "'{label}'-Filter anwenden",
    addCustom: 'Benutzerdefinierten Schnellfilter hinzufügen',
    removeCustom: 'Benutzerdefinierten Schnellfilter entfernen',
    createTitle: 'Benutzerdefinierten Schnellfilter erstellen',
    deleteTitle: 'Schnellfilter löschen',
    deleteMessage: "Möchten Sie den Schnellfilter '{label}' wirklich löschen?",
    nameLabel: 'Filtername',
    namePlaceholder: 'Geben Sie einen Namen für diesen Filter ein...',
    colorLabel: 'Farbe',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    delete: 'Löschen',
    nameRequired: 'Bitte geben Sie einen Namen für den Filter ein',
    colors: {
      '': 'Standard',
      red: 'Rot',
      green: 'Grün',
      blue: 'Blau',
      yellow: 'Gelb',
      orange: 'Orange',
      purple: 'Lila',
      brown: 'Braun'
    }
  },

  textOperators: {
    equals: 'Ist gleich',
    notEquals: 'Ist nicht gleich',
    contains: 'Enthält',
    startsWith: 'Beginnt mit',
    endsWith: 'Endet mit',
    greaterThan: 'Größer als',
    lessThan: 'Kleiner als',
    greaterThanOrEqual: 'Größer oder gleich',
    lessThanOrEqual: 'Kleiner oder gleich'
  },

  dateOperators: {
    isOn: 'Ist am',
    isNotOn: 'Ist nicht am',
    isAfter: 'Ist nach',
    isBefore: 'Ist vor',
    isOnOrAfter: 'Ist am oder nach',
    isOnOrBefore: 'Ist am oder vor'
  },

  columns: {
    autoSizeColumn: 'Spalte automatisch anpassen',
    hideColumn: 'Spalte ausblenden',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    moveUpDisabled: '\'{column}\' kann nicht nach oben verschoben werden',
    moveDownDisabled: '\'{column}\' kann nicht nach unten verschoben werden',
    atLeastOneRequired: '(Mindestens eine Spalte erforderlich)',
    fixedPosition: '(Feste Position)',
    column: 'Spalte',
    hideColumnTitle: 'Spalte \'{column}\' ausblenden',
    showColumnTitle: 'Spalte \'{column}\' einblenden',
    visibilityRequiredTitle: '\'{column}\' muss sichtbar bleiben'
  },

  aria: {
    clickToSortBy: "Klicken um nach '{column}' zu sortieren",
    optionsFor: "Optionen für '{column}'",
    filterOperatorFor: "Filter-Operator für '{column}'",
    filter: "Suche in '{column}'",
    clearFilterFor: "Filter für '{column}' löschen",
    filterByDate: "Nach '{column}' Datum filtern",
    clearDateFilterFor: "Datumsfilter für '{column}' löschen",
    filterOptionsFor: "Filteroptionen für '{column}'",
    toggleFilterFor: 'Filter für {option} umschalten',
    clearAllFiltersFor: "Alle Filter für '{column}' löschen",
    additionalFilterOptions: 'Zusätzliche Filteroptionen',
    autoSizeColumn: "Spalte '{column}' automatisch anpassen",
    hideColumn: "Spalte '{column}' ausblenden",
    columnVisibilityOptions: 'Optionen für Spaltensichtbarkeit',
    moveColumnUp: "'{column}' nach oben verschieben",
    moveColumnDown: "'{column}' nach unten verschieben",
    moveColumnUpDisabled: "'{column}' ist bereits ganz oben",
    moveColumnDownDisabled: "'{column}' ist bereits ganz unten",
    hideColumnCheckbox: "Spalte '{column}' ausblenden",
    showColumnCheckbox: "Spalte '{column}' einblenden",
    columnVisibleRequired: "Spalte '{column}' muss sichtbar bleiben",
    resizeColumn: "'{column}' Größe ändern"
  },

  tooltips: {
    reloadData: 'Tabellendaten neu laden',
    openColumnSettings: 'Spalteneinstellungen öffnen',
    dragToResize: 'Ziehen um Spalte zu vergrößern, Doppelklick für automatische Anpassung',
    autoFitColumns: 'Spalten automatisch an verfügbaren Platz anpassen'
  }
};
